import PropTypes from 'prop-types';
import React from 'react';

const SocialIcons = ({ facebookLink, instagramLink }) => {
  return (
    <>
      <a href="https://twitter.com/belmond" aria-label="twitter">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="social-icon logo-twitter"
          role="img"
          aria-hidden="true"
          viewBox="0 0 274 223"
          focusable="false"
          style={{
            height: '20px',
            marginBottom: '5px',
          }}
        >
          <title>Twitter</title>
          <path
            fill="currentColor"
            d="M 85.98 223 c -31.675 0 -61.158 -9.285 -85.98 -25.199 c 4.388 0.518 8.853 0.783 13.38 0.783 c 26.278 0 50.463 -8.967 69.659 -24.01 c -24.544 -0.453 -45.258 -16.669 -52.395 -38.953 a 56.014 56.014 0 0 0 10.552 1.006 c 5.116 0 10.071 -0.685 14.778 -1.967 c -25.66 -5.152 -44.993 -27.822 -44.993 -54.998 c 0 -0.236 0 -0.471 0.004 -0.705 a 55.865 55.865 0 0 0 25.406 7.015 c -15.05 -10.058 -24.953 -27.226 -24.953 -46.685 c 0 -10.279 2.766 -19.914 7.594 -28.198 c 27.664 33.934 68.993 56.264 115.609 58.603 a 56.31 56.31 0 0 1 -1.453 -12.782 c 0 -30.975 25.114 -56.088 56.091 -56.088 c 16.132 0 30.709 6.812 40.941 17.713 a 112.328 112.328 0 0 0 35.617 -13.611 c -4.188 13.097 -13.081 24.089 -24.662 31.031 a 112.148 112.148 0 0 0 32.215 -8.832 a 114 114 0 0 1 -27.988 29.035 c 0.108 2.405 0.162 4.824 0.162 7.256 C 245.564 137.533 189.148 223 85.98 223"
          ></path>
        </svg>
      </a>
      <a href={facebookLink} aria-label="facebook">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="social-icon logo-facebook"
          role="img"
          aria-hidden="true"
          viewBox="0 0 256 256"
          focusable="false"
          style={{
            height: '20px',
            marginBottom: '5px',
          }}
        >
          <title>Facebook</title>
          <path
            fill="currentColor"
            fillRule="evenodd"
            d="M 241.871 256.001 c 7.802 0 14.129 -6.326 14.129 -14.129 V 14.129 C 256 6.325 249.673 0 241.871 0 H 14.129 C 6.324 0 0 6.325 0 14.129 v 227.743 c 0 7.803 6.324 14.129 14.129 14.129 h 227.742 Z m -65.236 0 v -99.137 h 33.277 l 4.982 -38.635 h -38.259 V 93.561 c 0 -11.186 3.107 -18.809 19.148 -18.809 l 20.459 -0.009 V 40.188 c -3.54 -0.471 -15.684 -1.523 -29.812 -1.523 c -29.498 0 -49.692 18.005 -49.692 51.071 v 28.493 h -33.362 v 38.635 h 33.362 v 99.137 h 39.897 Z"
          ></path>
        </svg>
      </a>
      <a href={instagramLink} aria-label="instagram">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="social-icon logo-instagram"
          role="img"
          aria-hidden="true"
          viewBox="0 0 256 256"
          focusable="false"
          style={{
            height: '20px',
            marginBottom: '5px',
          }}
        >
          <title>instagram</title>

          <path
            fill="currentColor"
            d="M 128 23.064 c 34.177 0 38.225 0.13 51.722 0.745 c 12.48 0.57 19.258 2.655 23.769 4.408 c 5.974 2.322 10.238 5.096 14.717 9.575 c 4.48 4.479 7.253 8.743 9.575 14.717 c 1.753 4.511 3.838 11.289 4.408 23.768 c 0.615 13.498 0.745 17.546 0.745 51.723 c 0 34.178 -0.13 38.226 -0.745 51.723 c -0.57 12.48 -2.655 19.257 -4.408 23.768 c -2.322 5.974 -5.096 10.239 -9.575 14.718 c -4.479 4.479 -8.743 7.253 -14.717 9.574 c -4.511 1.753 -11.289 3.839 -23.769 4.408 c -13.495 0.616 -17.543 0.746 -51.722 0.746 c -34.18 0 -38.228 -0.13 -51.723 -0.746 c -12.48 -0.57 -19.257 -2.655 -23.768 -4.408 c -5.974 -2.321 -10.239 -5.095 -14.718 -9.574 c -4.479 -4.48 -7.253 -8.744 -9.574 -14.718 c -1.753 -4.51 -3.839 -11.288 -4.408 -23.768 c -0.616 -13.497 -0.746 -17.545 -0.746 -51.723 c 0 -34.177 0.13 -38.225 0.746 -51.722 c 0.57 -12.48 2.655 -19.258 4.408 -23.769 c 2.321 -5.974 5.095 -10.238 9.574 -14.717 c 4.48 -4.48 8.744 -7.253 14.718 -9.575 c 4.51 -1.753 11.288 -3.838 23.768 -4.408 c 13.497 -0.615 17.545 -0.745 51.723 -0.745 M 128 0 C 93.237 0 88.878 0.147 75.226 0.77 c -13.625 0.622 -22.93 2.786 -31.071 5.95 c -8.418 3.271 -15.556 7.648 -22.672 14.764 C 14.367 28.6 9.991 35.738 6.72 44.155 C 3.555 52.297 1.392 61.602 0.77 75.226 C 0.147 88.878 0 93.237 0 128 c 0 34.763 0.147 39.122 0.77 52.774 c 0.622 13.625 2.785 22.93 5.95 31.071 c 3.27 8.417 7.647 15.556 14.763 22.672 c 7.116 7.116 14.254 11.492 22.672 14.763 c 8.142 3.165 17.446 5.328 31.07 5.95 c 13.653 0.623 18.012 0.77 52.775 0.77 s 39.122 -0.147 52.774 -0.77 c 13.624 -0.622 22.929 -2.785 31.07 -5.95 c 8.418 -3.27 15.556 -7.647 22.672 -14.763 c 7.116 -7.116 11.493 -14.254 14.764 -22.672 c 3.164 -8.142 5.328 -17.446 5.95 -31.07 c 0.623 -13.653 0.77 -18.012 0.77 -52.775 s -0.147 -39.122 -0.77 -52.774 c -0.622 -13.624 -2.786 -22.929 -5.95 -31.07 c -3.271 -8.418 -7.648 -15.556 -14.764 -22.672 C 227.4 14.368 220.262 9.99 211.845 6.72 c -8.142 -3.164 -17.447 -5.328 -31.071 -5.95 C 167.122 0.147 162.763 0 128 0 Z m 0 62.27 c -36.302 0 -65.73 29.43 -65.73 65.73 c 0 36.302 29.428 65.73 65.73 65.73 c 36.301 0 65.73 -29.428 65.73 -65.73 c 0 -36.301 -29.429 -65.73 -65.73 -65.73 Z m 0 108.397 c -23.564 0 -42.667 -19.103 -42.667 -42.667 S 104.436 85.333 128 85.333 s 42.667 19.103 42.667 42.667 s -19.103 42.667 -42.667 42.667 Z m 83.686 -110.994 c 0 8.484 -6.876 15.36 -15.36 15.36 c -8.483 0 -15.36 -6.876 -15.36 -15.36 c 0 -8.483 6.877 -15.36 15.36 -15.36 c 8.484 0 15.36 6.877 15.36 15.36 Z"
          ></path>
        </svg>
      </a>
    </>
  );
};

SocialIcons.propTypes = {
  instagramLink: PropTypes.string,
  facebookLink: PropTypes.string,
};

export default SocialIcons;
